import React, { createContext, useContext, useState, useCallback } from 'react';

interface WorkflowTitleContextType {
    workflowTitle: string | null;
    setWorkflowTitle: (title: string | null) => void;
}

const WorkflowTitleContext = createContext<WorkflowTitleContextType | undefined>(undefined);

export function WorkflowTitleProvider({ children }: { children: React.ReactNode }) {
    const [workflowTitle, setWorkflowTitle] = useState<string | null>(null);

    const updateTitle = useCallback((title: string | null) => {
        setWorkflowTitle(title);
    }, []);

    return (
        <WorkflowTitleContext.Provider value={{ workflowTitle, setWorkflowTitle: updateTitle }}>
            {children}
        </WorkflowTitleContext.Provider>
    );
}

export function useWorkflowTitle() {
    const context = useContext(WorkflowTitleContext);
    if (context === undefined) {
        throw new Error('useWorkflowTitle must be used within a WorkflowTitleProvider');
    }
    return context;
}

